/* eslint-disable */
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ZipcodeService from '../../../../services/zipcodeService';
import { getTranslations } from '../../../../services/languageUtils';

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      street: '',
      district: '',
      city: '',
      state: '',
      number: '',
      complement: '',
      zipcode: '',
      country: 'Brasil',
      address: [],

      dangerStreet: false,
      dangerDistrict: false,
      dangerCity: false,
      dangerState: false,
      dangerNumber: false,
      dangerZipcode: false,
      translations: {}
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
    try{
      if(this.props.zipcode !== '')
        document.getElementById("zipcode").value = this.props.zipcode;
      if(this.props.address.length > 0){
        this.setState({
          address: this.props.address,
        })
      }
      else{
        if(this.state.address.length === 0)
          this.addAddress();
      }
    }
    catch(err){
      console.log(err);
    }
  }

  searchZipcode(value) {
    this.setState({dangerZipcode: false});
       var cep = value.replace(/\D/g, '');
       if (cep != "") {
           var validatecep = /^[0-9]{8}$/;

           if(validatecep.test(cep)) {
             let that = this;
             ZipcodeService.searchZipcode(cep).then(function(res){
               let inputValueStates;
               switch(res.data.uf){
                case 'AL':
                  inputValueStates = {value: 'AL', label: 'Alagoas'};
                  break;
                case 'AP':
                  inputValueStates = {value: 'AP', label: 'Amapá'};
                  break;
                case 'AM':
                  inputValueStates = {value: 'AM', label: 'Amazonas'};
                  break;
                case 'BA':
                  inputValueStates = {value: 'BA', label: 'Bahia'};
                  break;
                case 'CE':
                  inputValueStates = {value: 'CE', label: 'Ceará'};
                  break;
                case 'DF':
                  inputValueStates = {value: 'DF', label: 'Distrito Federal'};
                  break;
                case 'ES':
                  inputValueStates = {value: 'ES', label: 'Espírito Santo'};
                  break;
                case 'GO':
                  inputValueStates = {value: 'GO', label: 'Goiás'};
                  break;
                case 'MA':
                  inputValueStates = {value: 'MA', label: 'Maranhão'};
                  break;
                case 'MT':
                  inputValueStates = {value: 'MT', label: 'Mato Grosso'};
                  break;
                case 'MS':
                  inputValueStates = {value: 'MS', label: 'Mato Grosso do Sul'};
                  break;
                case 'MG':
                  inputValueStates = {value: 'MG', label: 'Minas Gerais'};
                  break;
                case 'PA':
                  inputValueStates = {value: 'PA', label: 'Pará'};
                  break;
                case 'PB':
                  inputValueStates = {value: 'PB', label: 'Paraíba'};
                  break;
                case 'PR':
                  inputValueStates = {value: 'PR', label: 'Paraná'};
                  break;
                case 'PE':
                  inputValueStates = {value: 'PE', label: 'Pernambuco'};
                  break;
                case 'PI':
                  inputValueStates = {value: 'PI', label: 'Piauí'};
                  break;
                case 'RJ':
                  inputValueStates = {value: 'RJ', label: 'Rio de Janeiro'};
                  break;
                case 'RN':
                  inputValueStates = {value: 'RN', label: 'Rio Grande do Norte'};
                  break;
                case 'RS':
                  inputValueStates = {value: 'RS', label: 'Rio Grande do Sul'};
                  break;
                case 'RO':
                  inputValueStates = {value: 'RO', label: 'Rondônia'};
                  break;
                case 'RR':
                  inputValueStates = {value: 'RR', label: 'Roraima'};
                  break;
                case 'SC':
                  inputValueStates = {value: 'SC', label: 'Santa Catarina'};
                  break;
                case 'SP':
                  inputValueStates = {value: 'SP', label: 'São Paulo'};
                  break;
                case 'SE':
                  inputValueStates = {value: 'SE', label: 'Sergipe'};
                  break;
                case 'TO':
                  inputValueStates = {value: 'TO', label: 'Tocantins'};
                  break;
                default:
                  inputValueStates = {value: 'AL', label: 'Alagoas'};
               }
               that.setState({dangerStreet: false, dangerDistrict: false, dangerCity: false, dangerState: false});
               that.props.onChangeValue({target: {name: 'zipcode', value: value}});
               that.props.onChangeValue({target: {name: 'street', value: res.data.logradouro}});
               that.props.onChangeValue({target: {name: 'district', value: res.data.bairro}});
               that.props.onChangeValue({target: {name: 'city', value: res.data.localidade}});
               that.props.onChangeValue({target: {name: 'state', value: inputValueStates.value}});
             }).catch(function(err){
             });
           }
           else {
           }
       }
       else {
       }
   };

   nextStep() {
      let alert = false;

      if(this.props.street.length < 2){
        this.setState({dangerStreet: true});
        alert = true;
      }

      if(this.props.number === ''){
        this.setState({dangerNumber: true});
        alert = true;
      }

      if(this.props.district.length < 3){
        this.setState({dangerDistrict: true});
        alert = true;
      }

      if(this.props.state.length < 2){
        this.setState({dangerState: true});
        alert = true;
      }

      if(this.props.city.length < 3){
        this.setState({dangerCity: true});
        alert = true;
      }

      if(this.props.zipcode.length < 3){
        this.setState({dangerZipcode: true});
        alert = true;
      }

      if(alert){
        toast.error(this.state.translations.incompleteData);
        return;
      }
      this.props.onChangeValue({target: {name: 'step', value: 3}});
   }

   updateCountry(e) {
     // console.log(e);
   }

   addAddress() {
     let address = this.state.address;
     address.push({
       index: address.length,
       street: '',
       district: '',
       city: '',
       state: '',
       number: '',
       complement: '',
       zipcode: '',
     });
     this.setState({address: address});
   }

   searchZipcodeOthers(value, index) {
     let address = this.state.address;

     address[index].zipcode = value;

     this.setState({address: address});

     let cep = value.replace(/\D/g, '');
     if (cep != "") {
        let validatecep = /^[0-9]{8}$/;

        if(validatecep.test(cep)) {
          let that = this;
          ZipcodeService.searchZipcode(cep).then(function(res){
            let inputValueStates;
            switch(res.data.uf){
             case 'AL':
               inputValueStates = {value: 'AL', label: 'Alagoas'};
               break;
             case 'AP':
               inputValueStates = {value: 'AP', label: 'Amapá'};
               break;
             case 'AM':
               inputValueStates = {value: 'AM', label: 'Amazonas'};
               break;
             case 'BA':
               inputValueStates = {value: 'BA', label: 'Bahia'};
               break;
             case 'CE':
               inputValueStates = {value: 'CE', label: 'Ceará'};
               break;
             case 'DF':
               inputValueStates = {value: 'DF', label: 'Distrito Federal'};
               break;
             case 'ES':
               inputValueStates = {value: 'ES', label: 'Espírito Santo'};
               break;
             case 'GO':
               inputValueStates = {value: 'GO', label: 'Goiás'};
               break;
             case 'MA':
               inputValueStates = {value: 'MA', label: 'Maranhão'};
               break;
             case 'MT':
               inputValueStates = {value: 'MT', label: 'Mato Grosso'};
               break;
             case 'MS':
               inputValueStates = {value: 'MS', label: 'Mato Grosso do Sul'};
               break;
             case 'MG':
               inputValueStates = {value: 'MG', label: 'Minas Gerais'};
               break;
             case 'PA':
               inputValueStates = {value: 'PA', label: 'Pará'};
               break;
             case 'PB':
               inputValueStates = {value: 'PB', label: 'Paraíba'};
               break;
             case 'PR':
               inputValueStates = {value: 'PR', label: 'Paraná'};
               break;
             case 'PE':
               inputValueStates = {value: 'PE', label: 'Pernambuco'};
               break;
             case 'PI':
               inputValueStates = {value: 'PI', label: 'Piauí'};
               break;
             case 'RJ':
               inputValueStates = {value: 'RJ', label: 'Rio de Janeiro'};
               break;
             case 'RN':
               inputValueStates = {value: 'RN', label: 'Rio Grande do Norte'};
               break;
             case 'RS':
               inputValueStates = {value: 'RS', label: 'Rio Grande do Sul'};
               break;
             case 'RO':
               inputValueStates = {value: 'RO', label: 'Rondônia'};
               break;
             case 'RR':
               inputValueStates = {value: 'RR', label: 'Roraima'};
               break;
             case 'SC':
               inputValueStates = {value: 'SC', label: 'Santa Catarina'};
               break;
             case 'SP':
               inputValueStates = {value: 'SP', label: 'São Paulo'};
               break;
             case 'SE':
               inputValueStates = {value: 'SE', label: 'Sergipe'};
               break;
             case 'TO':
               inputValueStates = {value: 'TO', label: 'Tocantins'};
               break;
             default:
               inputValueStates = {value: 'AL', label: 'Alagoas'};
            }

            address[index].street = res.data.logradouro;
            address[index].district = res.data.bairro;
            address[index].city = res.data.localidade;
            address[index].state = inputValueStates.value;

            that.setState({address: address});
            that.props.onChangeValue({target: {name: 'address', value: address}});
           }).catch(function(err){
           });
        }
        else {
        }
      }
    }

   updateValue(event, index){
     let address = this.state.address;
     switch(event.target.name){
       case 'zipcode':
        this.searchZipcodeOthers(event.target.value, index);
        break;
       case 'street':
        address[index].street = event.target.value;
        break;
       case 'number':
        address[index].number = event.target.value;
        break;
       case 'complement':
        address[index].complement = event.target.value;
        break;
       case 'district':
        address[index].district = event.target.value;
        break;
       case 'state':
        address[index].state = event.target.value;
        break;
       case 'city':
        address[index].city = event.target.value;
        break;

       default:
         break;
     }
     this.setState({address: address});
     this.props.onChangeValue({target: {name: 'address', value: address}});
   }

   render() {
    return (
      <div className="sideRightContent">
        <div className="textContentSteps">
          <div className="h1" style={{maxWidth: "500px"}}>
            <div className="h1Label">
              <img src={require("../../../../assets/imgs/ico-higher-titulo.svg").default} alt={this.state.translations.logoAlt} className="titleImage"/>
            </div>
            <div className="h1LabelMobile">
              2
            </div>
            {this.state.translations.addressTitle}
          </div>
          <br/>

          <p className="h5">&nbsp;Insira seu endereço de residência</p><br/>

          <div className="contentInputs contentInputSmall">
            <p className="label">CEP</p>
            <input inputMode="numeric" className={"input "+(this.state.dangerZipcode?"inputDanger":"")} type="text" id="zipcode" onKeyUp={(e) => this.searchZipcode(e.target.value)}></input>
          </div>

          <div className="contentInputs contentInputLarge">
            <p className="label">Logradouro</p>
            <input className={"input "+(this.state.dangerStreet?"inputDanger":"")} value={this.props.street} type="text" name="street" maxLength="100" onChange={(e) => {this.props.onChangeValue(e); this.setState({dangerStreet: false});}}></input>
          </div>

          <div className="contentInputs contentInputVerySmall">
            <p className="label">Nº</p>
            <input inputMode="numeric" className={"input "+(this.state.dangerNumber?"inputDanger":"")} value={this.props.number} type="text" name="number" maxLength="100" onChange={(e) => {this.props.onChangeValue(e); this.setState({dangerNumber: false});}}></input>
          </div>

          <div className="contentInputs contentInputMedium">
            <p className="label">Bairro</p>
            <input className={"input "+(this.state.dangerDistrict?"inputDanger":"")} value={this.props.district} type="text" name="district" maxLength="100" onChange={(e) => {this.props.onChangeValue(e); this.setState({dangerDistrict: false});}}></input>
          </div>

          <div className="contentInputs contentInputSmall">
            <p className="label">UF</p>
            <input className={"input "+(this.state.dangerState?"inputDanger":"")} value={this.props.state} type="text" name="state" maxLength="2" onChange={(e) => {this.props.onChangeValue(e); this.setState({dangerState: false});}}></input>
          </div>

          <div className="contentInputs contentInputLarge">
            <p className="label">Cidade</p>
            <input className={"input "+(this.state.dangerCity?"inputDanger":"")} value={this.props.city} type="text" name="city" maxLength="100" onChange={(e) => {this.props.onChangeValue(e); this.setState({dangerCity: false});}}></input>
          </div>
        </div>

        <div className="lineBtnSaveAndContinue">
          <div className="btnBack" onClick={() => {this.props.onChangeValue({target: {name: 'step', value: 1}});}}>
            {this.state.translations.goBack}
            <div className="arrow">
              <img src={require("../../../../assets/imgs/seta-left-cinza.svg").default} alt={this.state.translations.goBackArrowAlt} className="arrowBack"/>
            </div>
            <div className="space"></div>
          </div>
          <div className="btnSaveAndContinue" onClick={() => {this.nextStep();}}>
            {this.state.translations.saveAndProceed}
            <div className="arrow">
              <img src={require("../../../../assets/imgs/seta-right-branca.svg").default} alt={this.state.translations.saveAndProceedArrowAlt} className="arrowNext"/>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Step3;
